const RouteNames = {
    INDEX: 'audience-manager-index',
    
    BUILDER: 'audience-manager-builder',
    NEW_AUDIENCE: 'audience-manager-new-audience',
    BUILDER_QUICKSTART_TAB: 'audience-manager-builder-quickstart-tab',
    BUILDER_QUESTION_TAB: 'audience-manager-builder-question-tab',
    BUILDER_OVERVIEW_TAB: 'audience-manager-builder-overview-tab'
};

const BuilderTabIds = {
    QUICKSTART: 'Quickstart',
    OVERVIEW: 'Overview'   
};

export {
    RouteNames,
    BuilderTabIds
};